// ============================================
// App.js - Main Entry Point for Cyfrowy.ai
// ============================================

import React from 'react';
import CyfrowyAI from './components/cyfrowy_ai';
import './components/cyfrowy_ai.css';

// Optional: Reset styles
const globalStyles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
`;

function App() {
  return (
    <div className="App">
      <style>{globalStyles}</style>
      <CyfrowyAI />
    </div>
  );
}

export default App;


// ============================================
// Alternative: If using with TypeScript
// ============================================
/*
import React, { FC } from 'react';
import CyfrowyAI from './components/cyfrowy_ai';
import './components/cyfrowy_ai.css';

const App: FC = () => {
  return (
    <div className="App">
      <CyfrowyAI />
    </div>
  );
};

export default App;
*/


// ============================================
// index.js - React Root Entry Point
// ============================================
/*
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/


// ============================================
// index.css - Global Styles (Optional)
// ============================================
/*
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0a0e27;
  color: #ffffff;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

#root {
  width: 100%;
  margin: 0;
  padding: 0;
}
*/
